
import { Route, Routes } from 'react-router';
import './App.css';
import HomePage from './Pages/HomePage/HomePage';
import AboutUsPage from './Pages/AboutUsPage/AboutUsPage';
import ContactPage from './Pages/ContactPage/ContactPage';
import ManagamentPage from './Pages/ManagementPage/ManagamentPage';
import SupportPage from './Pages/SupportPage/SupportPage';
import EmployessPage from './Pages/EmployeesPage/EmployeesPage'
import EmployessDetailPage from './Pages/EmployeesPage/EmployessDetailPage';
import ServicesPage from './Pages/ServicesPage/ServicesPage';
import AdminEmployess from './Pages/AdminPage/Employess/AdminEmployess';
import UpdateEmployess from './Pages/AdminPage/Employess/UpdateEmployess';
import AdminCreateEmployess from './Pages/AdminPage/Employess/AdminCreateEmployess';
import AdminSupport from './Pages/AdminPage/Support/AdminSupport';
import UpdateSupport from './Pages/AdminPage/Support/UpdateSupport';
import AdminEmployessDetail from './Pages/AdminPage/Employess/AdminEmployessDetail';
import DashBoardPage from './Pages/AdminPage/DashBoardPage';
import CompletedSupport from './Pages/AdminPage/Support/CompletedSupport';
import AdminManager from './Pages/AdminPage/Manager/AdminManager';
import AdminManagerUpdate from './Pages/AdminPage/Manager/AdminManagerUpdate';
import AdminCreateManager from './Pages/AdminPage/Manager/AdminCreateManager';
import LoginPage from './Pages/Login/LoginPage';
import AuditPage from './Pages/AdminPage/Manager/Audit/AuditPage';
import UnitPage from './Pages/AdminPage/Manager/Unit/UnitPage';
import NoticesPage from './Pages/NoticesPage/NoticesPage';
import NoticeDetails from './Components/Notice/NoticeDetails/NoticeDetails';
import AdminNoticePage from './Pages/AdminPage/Notice/AdminNoticePage';
import AdminUpdateNotice from './Pages/AdminPage/Notice/AdminUpdateNotice';
import AdminCreateNotice from './Pages/AdminPage/Notice/AdminCreateNotice';
import NotFoundPage from './Components/NotFoundPage/NotFoundPage';


function App() {
  return (
    <Routes>
        <Route path='/' element={<HomePage/>}/>
        <Route path='/hakkimizda' element={<AboutUsPage/>}/>
        <Route path='/iletisim' element={<ContactPage/>}/>
        <Route path='/yonetim' element={<ManagamentPage/>}/>
        <Route path='/calisanlar' element={<EmployessPage/>}/>
        <Route path='/calisanlar/:id' element={<EmployessDetailPage/>}/>
        <Route path='/hizmetlerimiz' element={<ServicesPage/>}/>
        <Route path='/destek' element={<SupportPage/>}/>
        <Route path='/login' element={<LoginPage/>}/>
        <Route path='/duyurular' element={<NoticesPage/>}/>
        <Route path='/duyurular/:title' element={<NoticeDetails/>}/>
        <Route path="*" element={<NotFoundPage />} />

        <Route path='/admin/*'>

            <Route index element={<DashBoardPage/>} />
            <Route path='employess' element={<AdminEmployess/>} />
            <Route path='employess/update/:id' element={<UpdateEmployess/>} />
            <Route path='employess/:id' element={<AdminEmployessDetail/>} />
            <Route path='employess/create' element={<AdminCreateEmployess/>} />
            <Route path='support' element={<AdminSupport/>} />
            <Route path='support/completed' element={<CompletedSupport/>} />
            <Route path='support/update/:id' element={<UpdateSupport/>} />
            <Route path='manager' element={<AdminManager/>} />
            <Route path='manager/update/:id' element={<AdminManagerUpdate/>} />
            <Route path='manager/create' element={<AdminCreateManager/>} />
            <Route path='audit' element={<AuditPage/>} />
            <Route path='unit' element={<UnitPage/>} />
            <Route path='notice' element={<AdminNoticePage/>} />
            <Route path='notice/update/:id' element={<AdminUpdateNotice/>} />
            <Route path='notice/create' element={<AdminCreateNotice/>} />
        </Route>
   </Routes>
  );
}

export default App;
